<script setup lang="ts">
import PasswordInput from "@overlay/coreComponents/PasswordInput.vue";
import { computed, onMounted, ref } from "vue";
import { signupData } from "../data";
import InfoTip from "./InfoTip.vue";
import useStepEmits from "./useStepEmits";

defineEmits(["stepComplete", "stepLoading"]);

const { emitStepCompleted } = useStepEmits();
const passwordRepeat = ref("");

const validationRegexes = {
  upperCase: /(.*[A-Z].*)/,
  lowerCase: /(.*[a-z].*)/,
  digit: /(.*\d.*)/,
  symbol: /(.*\W.*)/,
};
const isPasswordValid = computed(
  () =>
    validationRegexes.upperCase.test(signupData.password) &&
    validationRegexes.lowerCase.test(signupData.password) &&
    validationRegexes.symbol.test(signupData.password) &&
    signupData.password.length > 7,
);
function handleInput() {
  if (isPasswordValid.value && signupData.password == passwordRepeat.value) {
    emitStepCompleted(true);
  } else {
    emitStepCompleted(false);
  }
}
</script>
<template>
  <label v-depixel for="password">{{ $t("global.your-password") }}</label>
  <info-tip>{{ $t("pages.signup.password.tip") }}</info-tip>

  <password-input
    id="first-password"
    v-model="signupData.password"
    @input="handleInput"
  />
  <div
    v-depixel-outlined
    class="requirements flex vertical gap--xxs padding--xs"
  >
    <span
      :class="{
        complete: validationRegexes.upperCase.test(signupData.password),
      }"
    >
      {{ $t("pages.signup.password.at-least") }} 1
      {{ $t("global.uppercase-letter").toLocaleLowerCase() }}
    </span>
    <span
      :class="{
        complete: validationRegexes.lowerCase.test(signupData.password),
      }"
    >
      {{ $t("pages.signup.password.at-least") }} 1
      {{ $t("global.lowercase-letter").toLocaleLowerCase() }}
    </span>
    <span
      :class="{
        complete: validationRegexes.symbol.test(signupData.password),
      }"
    >
      {{ $t("pages.signup.password.at-least") }} 1
      {{ $t("global.special-character").toLocaleLowerCase() }} ( ! @ % & * )
    </span>
    <span
      :class="{
        complete: signupData.password.length > 7,
      }"
    >
      {{ $t("pages.signup.password.minimum") }} 8
      {{ $t("global.character", 2).toLocaleLowerCase() }}
    </span>
  </div>
  <label v-depixel for="passwordRepeat">
    {{ $t("global.repeat") }} {{ $t("global.password").toLocaleLowerCase() }}:
  </label>
  <password-input v-model="passwordRepeat" @input="handleInput" />
</template>
<style scoped lang="scss">
.requirements {
  span {
    font-size: 10px;
    &:not(.complete) {
      opacity: 0.7;
    }
    &::before {
      display: inline-block;
      content: "";
      width: get-size(xsm);
      height: get-size(xsm);
      background-color: get-color(white-350);
      border-radius: 100%;
      margin-right: get-size(xs);
    }
    &.complete::before {
      background-color: get-color(green-150);
    }
  }
}
</style>
